import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { makeStyles } from "tss-react/mui";

interface Props {
	/** Body copy. */
	children: React.ReactNode;
	/** Optional call-to-action rendered below the copy — typically a link. */
	action?: React.ReactNode;
	className?: string;
}

const useStyles = makeStyles()((theme) => ({
	body: {
		fontSize: 14,
		lineHeight: "20px",
		color: theme.palette.custom.textPrimary,
	},
	action: {
		marginTop: theme.spacing(0.5),
		fontSize: 14,
	},
}));

/**
 * Persistent, low-emphasis informational notice. Deliberately has no dismiss affordance: it is for
 * context that stays true rather than something the user acts on and clears (MAX-4139).
 *
 * Extracted from the Account page's billing banner, which is the same treatment.
 */
export const InfoBanner: React.FC<Props> = ({ children, action, className }) => {
	const { classes } = useStyles();
	return (
		<Mui.Box mb={2} className={className}>
			<Mui.Alert severity="info" icon={<Icons.Info size={20} />}>
				<Mui.Typography className={classes.body}>{children}</Mui.Typography>
				{action && <Mui.Box className={classes.action}>{action}</Mui.Box>}
			</Mui.Alert>
		</Mui.Box>
	);
};
